import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { init } from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

document.documentElement.setAttribute( 'data-version', environment.version );

if ( environment.name.startsWith( 'staging' ) ) {
    enableProdMode();
    // Sentry integration
    init( {
        environment: 'staging',
        release: 'scope-frontend@' + environment.version,
        dsn: 'https://22dfed699dac333e3296668cccb5f580@o1021883.ingest.sentry.io/4506541291274240',
        ignoreErrors: [
            'BrowserAuthError',
            'ClientAuthError',
            'InteractionRequiredAuthError',
            'ServerError',
            'NG0901',
            'NG02100', // abandoned date pipe
            'JSON-RPC', // 403 api response
            'interaction_required',
            'server_error: AADB2C90273', // auth error
            'monitor_window_timeout',
            'Unknown Error',
            'user.read',
            'ethereum'
        ]
    } );
}

bootstrapApplication( AppComponent, appConfig )
    .catch( ( err ) => console.error( err ) );
